/**
 * @generated SignedSource<<c2dd9f0abc5a6ad76fe83acfa9901cbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNotificationsIcon_viewer$data = {
  readonly userNotifications: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetAllUnviewedNotifications_userNotifications">;
  } | null;
  readonly " $fragmentType": "UserNotificationsIcon_viewer";
};
export type UserNotificationsIcon_viewer$key = {
  readonly " $data"?: UserNotificationsIcon_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserNotificationsIcon_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserNotificationsIcon_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "UserNotifications",
      "kind": "LinkedField",
      "name": "userNotifications",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetAllUnviewedNotifications_userNotifications"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a850015d55386825e213919a47c48fc1";

export default node;
